export default __webpack_public_path__ + "static/media/Clinic.a186e99c.svg";